// extracted by mini-css-extract-plugin
export var divider = "_qw-0";
export var systemMessage = "_qw-1";
export var systemMessageWrapper = "_qw-2";